module.exports = __webpack_public_path__ + "media/images/ninestars/team/team-2-b2008acdf74612d89b8f134e63e4f39f.jpg";